import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { BlueprintBackground } from "@/components/BlueprintBackground";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center px-4" data-testid="payment-cancel-page">
      <BlueprintBackground />
      <div className="w-full max-w-sm rounded-2xl border border-slate-700/60 bg-slate-900/80 backdrop-blur-md p-8 shadow-2xl text-center">
        <XCircle className="text-slate-400 mx-auto mb-4" size={32} />
        <h1 className="font-heading text-xl font-bold text-white mb-2">Checkout cancelled</h1>
        <p className="text-slate-400 text-sm mb-6">No charge was made. You can upgrade anytime from your dashboard.</p>
        <Link to="/dashboard" className="text-blue-400 hover:text-blue-300 text-sm font-medium" data-testid="payment-cancel-dashboard-link">
          Back to Dashboard
        </Link>
      </div>
    </div>
  );
}
